import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-background-icons-animation',
  templateUrl: './background-icons-animation.component.html',
  styleUrls: ['./background-icons-animation.component.scss']
})
export class BackgroundIconsAnimationComponent implements OnInit {
	@Input() title: string = '';
	@Input() description: string = '';
	@Input() titleKey: string = '';
	@Input() descriptionKey: string = '';
	isLoading: boolean = true;

	@Input()
	icons: Array<string> = [
		'destinations--culture',
		'destinations--stopover_experience',
		'destinations--tours_activities',
		'destinations--romance',
		'destinations--snow',
		'destinations--shopping',
		'destinations--night_life',
		'destinations--nature',
		'destinations--surf',
		'destinations--beach',
		'destinations--adventure',
		'destinations--golf',
		'ancillaries--luggage',
		'ancillaries--hand_luggage',
		'luggage--music_equipment',
		'leisure_and_commodities--air_conditioning',
		'leisure_and_commodities--magazines',
		'leisure_and_commodities--music',
		'ancillaries--lounge',
		'booking--plane-flying',
		'general--search',
		'general--location',
		'interface--language',
		'loyalty--miles',
		'plane_related--eco-friendly'
	];

	itemRows = [6, 8];
	selectedIcons = [];

  constructor() { }

	ngOnInit() {
		this.TAP_initIcons();
	}

	TAP_initIcons() {
		this.selectedIcons = [];
		this.itemRows.forEach(itemsCount => {
			let rowIcons = [];
			for (let index = 0; index < itemsCount; index++) {
				rowIcons.push({
					id: this.TAP_getIcon(),
					position: this.TAP_getPosition() + '% ' + this.TAP_getPosition() + '% 0 0',
					class: this.TAP_getIconClass(),
				});
			}
		this.selectedIcons.push(rowIcons);
		});
	}

	TAP_getIcon() {
		const iconIndex = Math.floor(Math.random() * this.icons.length);
		const iconID = 'icons.svg#' + (this.icons[iconIndex]);

		this.icons.splice(iconIndex, 1);

		return iconID;
	}

	TAP_getPosition() {
		const MAX = 4;
		const MIN = 0;
		return (Math.floor(Math.random() * (MAX - MIN) ) + MIN);
	}

	TAP_getIconClass() {
		const MAX = 6;
		const MIN = 1;
		return 'icon--' + (Math.floor(Math.random() * (MAX - MIN) ) + MIN);
	}

}
